class MultilangText {
  en!: string;
  'pt-br'?: string;
  es?: string;
  ru?: string;
  ua?: string;
  it?: string;
  de?: string;
  fr?: string;
  et?: string;
  pl?: string;
  nl?: string;
  fi?: string;
  el?: string;
  ja?: string;
  th?: string;
  cn?: string;
  he?: string;
  ko?: string;
  sv?: string;
  no?: string;
  lt?: string;
  vn?: string;
  hu?: string;
  sk?: string;
  cs?: string;
  ro?: string;

  constructor(data?: any) {
    if (data?.constructor === String) {
      this.en = data as string;
      return;
    }
    Object.assign(this, data);
  }

  getText(lang = 'en'): string {
    return this[lang] || this.en;
  }
}

export default MultilangText;
